import { ArrowDownToLine, Package, Truck, ShieldCheck, FileCheck2 } from "lucide-react";
import { Phone } from "lucide-react";
import { PHONE_DISPLAY, PHONE_LINK, AREA } from "@/lib/constants";

const steps = [
  { icon: ArrowDownToLine, title: "Descente des cartons", desc: "Étages, caves, sous-sols, sans ascenseur." },
  { icon: Package, title: "Manutention complète", desc: "Emballage, étiquetage, chargement." },
  { icon: Truck, title: "Transport sécurisé", desc: "Véhicules dédiés, traçabilité totale." },
  { icon: ShieldCheck, title: "Destruction confidentielle", desc: "Broyage en centre agréé, conforme RGPD." },
  { icon: FileCheck2, title: "Certificat remis", desc: "Preuve officielle transmise après intervention." },
];

export default function NoTouch() {
  return (
    <section
      id="securite"
      className="relative py-20 md:py-32 bg-slate-950 text-white overflow-hidden"
      data-testid="notouch-section"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage:
            "linear-gradient(to right, #fff 1px, transparent 1px), linear-gradient(to bottom, #fff 1px, transparent 1px)",
          backgroundSize: "56px 56px",
          maskImage: "radial-gradient(ellipse at center, black 30%, transparent 80%)",
          WebkitMaskImage: "radial-gradient(ellipse at center, black 30%, transparent 80%)",
        }}
      />
      <div className="absolute -top-32 -right-32 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl" aria-hidden />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="max-w-3xl mx-auto text-center">
          <div className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-blue-400">
            Le service
          </div>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[1.04]" data-testid="notouch-title">
            Le client ne touche <span className="text-blue-400">à rien.</span>
          </h2>
          <p className="mt-5 text-lg md:text-xl text-slate-300 leading-relaxed">
            Pas de cartons à descendre. Pas de camion à louer. Pas de coordination logistique.
            <strong className="text-white"> Un appel suffit, nous repartons avec tout.</strong>
          </p>
        </div>

        {/* Flat list — zigzag on mobile (alt left/right), straight on desktop */}
        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-x-6 gap-y-10 md:gap-y-12">
          {steps.map(({ icon: Icon, title, desc }, i) => (
            <div
              key={title}
              className={`relative ${i % 2 === 1 ? "text-right md:text-left" : "text-left"}`}
              data-testid={`notouch-step-${title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
            >
              <Icon className="inline-block h-9 w-9 text-blue-300" strokeWidth={1.5} />
              <div className="mt-1.5 text-[10px] uppercase tracking-[0.2em] text-slate-500 font-bold">0{i + 1}</div>
              <h3 className="font-display mt-2 text-lg font-bold tracking-tight">{title}</h3>
              <p className="mt-2 text-sm text-slate-400 leading-relaxed">{desc}</p>
            </div>
          ))}
        </div>

        {/* Inline CTA */}
        <div className="mt-16 flex flex-col md:flex-row gap-5 md:items-center md:justify-between border-t border-white/10 pt-10" data-testid="notouch-cta">
          <div>
            <h3 className="font-display text-xl md:text-2xl font-bold">Une intervention à organiser ?</h3>
            <p className="text-slate-400 mt-1">Devis gratuit · Réponse sous 24h · Tout {AREA}.</p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3">
            <a href={`tel:${PHONE_LINK}`} className="inline-flex items-center justify-center gap-2 bg-white text-slate-950 font-bold py-3 px-5 rounded-full hover:bg-blue-100 transition-all" data-testid="notouch-call">
              <Phone className="h-4 w-4" strokeWidth={2} />
              {PHONE_DISPLAY}
            </a>
            <a href="#devis" className="inline-flex items-center justify-center gap-2 bg-blue-600 text-white font-bold py-3 px-5 rounded-full hover:bg-blue-700 transition-all" data-testid="notouch-quote">
              Demander un devis
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
